var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bag-in-shipment-live-response"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bag Details Live Response")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bag Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNumber),
      expression: "bagNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bagNumber",
      "placeholder": "Enter Bag Number"
    },
    domProps: {
      "value": (_vm.bagNumber)
    },
    on: {
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNumber = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.isBagNumberError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.BagNumberError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBagDetails
    }
  }, [_vm._v("Search")])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "60px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bay ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Open Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Close Time")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShipmentCount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created At")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.BagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.BagNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.BagDest))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.BagType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.BayId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.RouteMode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.requestData.BagOpenTime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.requestData.BagCloseTime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.BagWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestData.ShippingIds.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createdAt)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.openlistmodal(data.requestData)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.BagDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "11"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.listmodal = false
      }
    },
    model: {
      value: (_vm.listmodal),
      callback: function($$v) {
        _vm.listmodal = $$v
      },
      expression: "listmodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.bagNumber))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closelistmodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left1": "49px"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered mytable12 poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px",
      "width": "5%"
    }
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Package Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("InScan Time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("BagIn Time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("BagIn User")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v("Package Type")])])]), _vm._v(" "), _vm._l((_vm.modaldata), function(sdata) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.PackageType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.InScanTime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.BagInTime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.BagInUser))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.PackageType))])])])
  }), _vm._v(" "), (_vm.modaldata.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No record found")])])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('b', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Response: ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._l((_vm.modaldata), function(sdata) {
    return _c('span', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v("{ShippingId: " + _vm._s(sdata.ShippingId) + " , ")])
  }), _vm._v(" "), _vm._l((_vm.BagDetails), function(data, index) {
    return _c('span', {
      staticStyle: {
        "font-size": "15px"
      }
    }, [_vm._v("ReturnMessage: " + _vm._s(data.responseData.ReturnMessage) + "}")])
  })], 2)])]), _c('br')])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496074f2","hasScoped":true}!./src/views/components/FalconSorter/BagInShipmentLiveResponse/BagInShipmentLiveResponse.html
// module id = 1765
// module chunks = 2